import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import {
  YodleeLinkProvider,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/AggregatorButtonPicker/Yodlee/YodleeLinkContext';
import YodleeNewLinkModal from './yodleeNewLinkModal';

const YodleeLinkModal = ({
  institutionResource,
  syncFn,
  yodleeConfigLink,
  onComplete,
  onSyncStarted,
  ...rest
}) => {
  // BE VERY CAREFUL IN THIS FILE, changes here can easily cause yodlee to re-render and break the flow
  return (
    <YodleeLinkProvider
      resource={institutionResource}
      onLoadLink={syncFn}
      handleRefreshSuccess={syncFn}
      yodleeConfigLink={yodleeConfigLink}
      onComplete={onComplete}
      onSyncStarted={onSyncStarted}
    >
      <YodleeNewLinkModal institutionResource={institutionResource} syncFn={syncFn} {...rest} />
    </YodleeLinkProvider>
  );
};

YodleeLinkModal.defaultProps = {
  yodleeConfigLink: undefined,
  syncFn: undefined,
};

YodleeLinkModal.propTypes = {
  institutionResource: PropTypes.instanceOf(fr.Resource).isRequired,
  syncFn: PropTypes.func,
  yodleeConfigLink: PropTypes.object,
};

export default YodleeLinkModal;
